const sections = document.querySelectorAll("section[id]");
const navLinks = document.querySelectorAll(".faq-nav a");

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      navLinks.forEach(link => {
        link.classList.toggle(
          "current",
          link.getAttribute("href") === `#${entry.target.id}`
        );
      });
    }
  });
}, {
  // 画面中央付近を監視
  root: null,
  rootMargin: "-66.666% 0px -33.333% 0px",
  threshold: 0
});

sections.forEach(section => observer.observe(section));